import { Component, HostBinding, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FrontendFooterComponent } from './frontend-footer/frontend-footer.component';
import { AlertComponent } from '../../util/components/alert/alert.component';

@Component({
  selector: 'app-frontend',
  standalone: true,
  imports: [RouterModule, FrontendFooterComponent, AlertComponent],
  templateUrl: './frontend.component.html',
})
export default class FrontendComponent {
  @HostBinding() class = 'flex-grow flex flex-col';
  migrationBannerDismissed = signal<boolean>(
    localStorage.getItem('migration-banner') !== null,
  );

  dismissBanner() {
    localStorage.setItem('migration-banner', 'dismissed');
    this.migrationBannerDismissed.set(true);
  }
}
